import PageContent from "../../app/layouts/PageContent";
import CoachDashboard from "./CoachDashboard/CoachDashboard";
import { useProfile } from "../auth/hooks/useProfile";
import UserDashboard from "./UserDashboard";

const LockerRoom = () => {
  document.title = `Locker Room - ${process.env.REACT_APP_NAME}`;

  const { isCoach } = useProfile();

  return (
    <PageContent>
      {isCoach ? <CoachDashboard /> : <UserDashboard />}
    </PageContent>
  );
};

export default LockerRoom;
